import {
  Waves,
  Wifi,
  Car,
  UtensilsCrossed,
  TreePine,
  AirVent,
  Tv,
  WashingMachine,
  type LucideIcon,
} from 'lucide-react';

export interface Amenity {
  id: string;
  icon: LucideIcon;
  translationKey: string;
}

export const amenities: Amenity[] = [
  { id: 'pool', icon: Waves, translationKey: 'pool' },
  { id: 'wifi', icon: Wifi, translationKey: 'wifi' },
  { id: 'parking', icon: Car, translationKey: 'parking' },
  { id: 'restaurant', icon: UtensilsCrossed, translationKey: 'restaurant_amenity' },
  { id: 'gardens', icon: TreePine, translationKey: 'gardens' },
  { id: 'ac', icon: AirVent, translationKey: 'ac' },
  { id: 'tv', icon: Tv, translationKey: 'tv' },
  { id: 'laundry', icon: WashingMachine, translationKey: 'laundry' },
];
